import { render, staticRenderFns } from "./PaywallGiftGroups.vue?vue&type=template&id=510efeb1&scoped=true&"
import script from "./PaywallGiftGroups.vue?vue&type=script&lang=ts&"
export * from "./PaywallGiftGroups.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallGiftGroups.vue?vue&type=style&index=0&id=510efeb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510efeb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('510efeb1', component.options)
    } else {
      api.reload('510efeb1', component.options)
    }
    module.hot.accept("./PaywallGiftGroups.vue?vue&type=template&id=510efeb1&scoped=true&", function () {
      api.rerender('510efeb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/PaywallGiftGroups.vue"
export default component.exports